import React, { useEffect, useRef, useState, useContext, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'dva';
// import {PullToRefresh} from 'antd-mobile'
import PullToRefresh from '@/components/PullRefresh';
import { router } from 'umi';
import Banner from '@/components/Banner';
import MovieItem from '@/components/MovieItem';
import CinemaItem from '@/components/CinemaItem';
import DFImage from '@/components/dFImage';
import { EIndexTypes } from '@/interface/index';
import { Context } from '../../index';
import SuspendServe from '@/components/SuspendServe';
import PullLoad from '@/components/PullLoad';
import { getBannerHeight } from '@/utils';
import { setDataGioList, checkExposureGio, clearGioStatus } from './gioUtils';
import styles from './index.less';
import Top_1 from './imgs/Bitmap_1.png';
import Top_2 from './imgs/Bitmap_2.png';
import Top_3 from './imgs/Bitmap_3.png';
import Top_4 from './imgs/Bitmap_4.png';
import Top_5 from './imgs/Bitmap_5.png';
import {TLang, ReplaceText} from '@/utils/lang';
import { LoadingInPage } from '@/public';
import ViewMoiveFood from '@/components/viewMovieFood';
import { init } from '@sentry/react';
import { gioClick } from '@/utils/gioApi';
import AudioAndVideo from './audioAndVideo';
interface IFutureMovieProps {
  data: any;
  top?: any;
  banner: any;
  bannerClick?: (i: number) => void;
  loadMore?: (t: EIndexTypes) => void;
  loading?: boolean;
  type: EIndexTypes;
  render?: any;
  init?: boolean;
}

const IndexLayout = (props: any) => {
  const rankSliderRef = useRef(null);
  const ptr: any = useRef(null);

  const refreshingMethod = (): void => {
    if (props.data && props.data.hasNext) {
      setRefreshing(true);
      props.loadMore && props.loadMore(props.type);
    } else {
      setRefreshing(false);
    }
  };
  const bannerRef: any = useRef();
  const [height, setHeight] = useState(1169);
  const [emptyHeight, setEmptyHeight] = useState(height);
  useEffect(() => {
    // ReactDOM.findDOMNode(ptr.current).offsetTop;
    const realDom: any = ReactDOM.findDOMNode(ptr.current);
    const hei = document.documentElement.clientHeight - realDom.offsetTop;
    setHeight(hei);
    if (bannerRef && bannerRef.current) {
      let dom = bannerRef.current.getBoundingClientRect();
      let h = hei - dom.height;
      setEmptyHeight(h);
    }
  }, [ptr]);
  // useEffect(() => {
  //   if (props.banner && props.banner.length > 0) {
  //     // 计算 高度
  //   }
  // }, [props.banner, height]);
  useEffect(() => {
    // console.log('layout loading', props.loading);
    if (props.loading) {
      setRefreshing(true);
    } else if (typeof props.loading === 'boolean') {
      setRefreshing(false);
    }
  }, [props.loading]);
  const [refreshing, setRefreshing] = useState(false);
  // useEffect(() => {
  //   // console.log(props)
  // }, [props.data]);
  const { state, dispatch } = useContext(Context);

  const noMovieEl = () => (
    <SuspendServe
      msg={TLang('当前城市暂无影片', 'home', false, false, null)}
      btn={{ onClick: changeCityHandle, text: TLang('切换城市', 'home', false, false, null) }}
      mHieght={null}
    // mHieght={Banner ? emptyHeight + 'px' : null}
    ></SuspendServe>
  );
  const noCinemaEl = () => (
    <SuspendServe
      msg={TLang('当前城市暂无影院', 'home', false, false, null)}
      btn={{ onClick: changeCityHandle, text: TLang('切换城市', 'home', false, false, null) }}
      mHieght={null}
    // mHieght={Banner ? emptyHeight + 'px' : null}
    ></SuspendServe>
  );
  const changeCityHandle = () => {
    // window.df_sdk_common.location.href = `/bfd-pagesite/citylist?allowback=true&returnurl=${encodeURIComponent(
    //   window.df_sdk_common.location.href,
    // )}`;
    props.dispatch &&
      props.dispatch({
        type: 'initData/setShowAddrPage',
        payload: true
      });
  };
  const gotoMovieDetail = (item: any, index) => {
    gioClick('电影-频道首页', {
      pagename: '电影首页',
      modulename: '票房榜单',
      elementname: '票房榜单',
      contentTitle: item?.name,
      floorNum: 3,
      HPbanenrNum: index+1,
      JumpAddress: window.location.origin + `/newmovie/movieDetail?id=${item.id}&orderBy=1`,
      channle: '电影'
    });
    router.push({
      pathname: '/movieDetail',
      query: {
        id: item.id,
        orderBy: 1 // 离我最近
      }
    });
  };
  const gotoCinema = useCallback((item) => {
    props.dispatch && props.dispatch({ type: 'cinema/setCimemaId', payload: item.id });
    router.push({
      pathname: '/cinema',
      query: {
        cid: item.id
      }
    });
  }, []);
  const bannerClick = (index) => {
    if (index >= props.banner.length) {
      return;
    }
    const imgs = props.banner[index];
    if (imgs && imgs.href) {
      window.df_sdk_common.location.href = imgs.href;
    }
  };

  /*** 曝光的代码 */
  const dataList = useRef(props.top);

  useEffect(() => {
    clearGioStatus();
    setDataGioList(props.top);
    dataList.current = props.top;
    const $dom = document.getElementById('homeRanking');
    if (props.top?.length > 0 && $dom) {
      checkExposureGio(dataList.current);
    }
  }, [props.top]);

  const gioExposure = () => {
   checkExposureGio(dataList.current);
  };

  useEffect(() => {
    const element = document.getElementById('pullToRefresh');
    element?.addEventListener('scroll', gioExposure);
    return () => {
      element?.removeEventListener('scroll', gioExposure);
    };
  }, [props.top]);

  useEffect(() => {
    const handleTouchStart = (event) => {
      const touch = event.touches[0];
      const startX = touch.pageX;
      rankSliderRef?.current?.addEventListener('touchmove', (event) => {
        gioExposure();
      });
    };
    rankSliderRef?.current?.addEventListener('touchstart', handleTouchStart);
    return () => {
      rankSliderRef?.current?.removeEventListener('touchstart', handleTouchStart);
    };
  }, [props.top]);
  /*** 曝光的代码 */

  return (
    <div className={`${styles.layoutContainer} layoutContainer`} id="layoutContainer">
      <PullToRefresh
        id="pullToRefresh"
        damping={50}
        ref={ptr}
        style={{
          height: height,
          overflow: 'auto',
          background: '#F7F7F7'
        }}
        direction="up"
        indicator={{
          activate: props.data?.hasNext
          ? <LoadingInPage></LoadingInPage>
          : <p className={styles.load}>{TLang('没有更多了', 'home', false, false, null)}</p>,
          deactivate: <p></p>,
          release: <p></p>,
          finish: <p></p>
        }}
        refreshing={refreshing}
        onRefresh={refreshingMethod}
        distanceToRefresh={50}
      >
        <div className="indexScrollWrapper">
          {props.banner && props.banner.length ? (
            <div ref={bannerRef} className={`${styles.bannerWrapper} banner-wrapper`}>
              <Banner
                imgsList={props.banner}
                clickImg={bannerClick}
                curIdx={state.curIdx}
                changeIndex={(i) => {
                  dispatch({ type: 'setCurIdx', idx: i });
                }}
                height={getBannerHeight()}
                autoPlay
                autoplayInterval={2000}
                dots
              ></Banner>
            </div>
          ) : null}
          {(props.type === EIndexTypes.cinema || props.type === EIndexTypes.future) && props?.onlineOrderList && props?.onlineOrderList.length > 0 && <ViewMoiveFood init={props?.init} type={props?.type} onlineOrderList={props?.onlineOrderList}/>}
          {props.type === EIndexTypes.cinema && props.data && props.data.searches.length > 0 ? (
            <div className={styles.cinemaContainer}>
              {props.render ? props.render : null}
              {props.data && props.data.searches && props.data.searches.length > 0 ? (
                <div className="allCItems">
                  {props.data.searches.map((item, idx) => (
                    <CinemaItem
                      {...item}
                      key={idx}
                      noBorder={idx === props.data.searches.length - 1}
                      onClick={gotoCinema}
                    />
                  ))}
                </div>
              ) : (
                <div style={{marginTop:'500px'}}>{noCinemaEl()}</div>
              )}
            </div>
          ) : null}
          {props.type === EIndexTypes.future &&
            props.data?.searches &&
            props.data.searches?.length ? (
              <div className={styles.futureContainer}>
                {props.data && props.data.searches && props.data.searches.length > 0 ? (
                  <div>
                    <div className={styles.header}>{TLang('即将上映', 'home', false, false, null)}</div>
                    {props.data.searches.map((item, idx) => (
                      <MovieItem {...item} showButton={item?.scheduleCount !== 0} key={idx} index={idx} type="future" />
                  ))}
                  </div>
              ) : (
                noMovieEl()
              )}
              </div>
          ) : null}
          {props.type === EIndexTypes.hot ? (
            <div className={styles.hotContainer}>
              {props.top && props.top.length > 0 && (
                <div className={styles.topWrapper}>
                  {props.top && props.top.length > 0 ? (
                    <>
                      <div className={styles.header}>{TLang('票房榜单', 'home', false, false, null)}</div>
                      <div className="scrollContainer">
                        <ul ref={rankSliderRef} className={styles.list} id="homeRanking">
                          {props.top.map((item, idx) => (
                            <li
                              key={idx}
                              className={styles.item}
                              onClick={() => gotoMovieDetail(item, idx)}
                              id={`homeRanking${idx}`}
                            >
                              <div className={`${styles.img} ${item.logo ? '' : 'logo'}`}>
                                <DFImage src={item.logo} key={item.id}></DFImage>
                              </div>
                              <p>{item.name}</p>
                              {idx === 0 ? <img className={styles.topImg} src={Top_1} /> : null}
                              {idx === 1 ? <img className={styles.topImg} src={Top_2} /> : null}
                              {idx === 2 ? <img className={styles.topImg} src={Top_3} /> : null}
                              {idx === 3 ? <img className={styles.topImg} src={Top_4} /> : null}
                              {idx === 4 ? <img className={styles.topImg} src={Top_5} /> : null}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </>
                  ) : null}
                </div>
              )}
              {props?.onlineOrderList && props?.onlineOrderList.length > 0 && <ViewMoiveFood init={props?.init} type={props?.type} onlineOrderList={props?.onlineOrderList}/>}
              {props?.audioInfo && <AudioAndVideo audioInfo={props?.audioInfo}/>}
              {props.data?.searches && props.data.searches?.length > 0 &&
              <div className={styles.hotRecommondWrapper}>
                <div>
                  <div className={styles.header}>{TLang('热映推荐', 'home', false, false, null)}</div>
                  {props.data.searches.map((item, idx) => (
                    <MovieItem {...item} key={idx} index={idx} type="hot" />
                    ))}
                </div>
              </div>}
            </div>
          ) : null}
          {(props.type === EIndexTypes.hot || props.type === EIndexTypes.future) &&
            props.data &&
            props.data.searches &&
            props.data.searches.length == 0
            ? noMovieEl()
            : null}
          {props.type === EIndexTypes.cinema &&
            props.data &&
            props.data.searches &&
            props.data.searches.length == 0
            ? noCinemaEl()
            : null}
        </div>
      </PullToRefresh>
    </div>
  );
};
export default connect()(IndexLayout);
